<template>
  <el-main>
    <!-- logo -->
    <div class="logo_area">
      <img class="logo_icon" src="~@/assets/image/login_logo_icon@2x.png" alt="">
      <img class="logo_text" src="~@/assets/image/login_logo_text@2x.png" alt="">
    </div>
    <!-- 页面描述 -->
    <div class="login_desc">
      <img class="logo_desc_img" src="~@/assets/image/login_text@2x.png" alt="">
      <div class="logo_desc_text">找车更简单 / 卖车更高效</div>
      <div class="row">
        <img class="jt" src="~@/assets/image/login_icon_jt@2x.png" alt="">
        <img class="jt" src="~@/assets/image/login_icon_jt@2x.png" alt="">
      </div>
    </div>

    <div class="login-box" v-if="is_show_login">

      <form @submit="loginSubmit" class="login">
        <div class="title">
          <p>Hello</p>
          <p>智慧门店登录</p>
        </div>
        <div class="form">
          <div class="password-input">
            <div class="account">
              <input class="account_input" type="text" placeholder="请输入账号" v-model="loginForm.account">
              <!-- <el-input v-model="loginForm.account" placeholder="请输入账号"></el-input> -->
            </div>
            <div class="code">
              <input class="account_input" type="password" placeholder="请输入密码" v-model="loginForm.password">
              <!-- <el-input type="password" v-model="loginForm.password" placeholder="请输入密码"></el-input> -->
            </div>
            <div class="forget-password">
              <div class="left">
                <el-checkbox v-model="is_remember" @change="getremember"></el-checkbox>
                <span>记住账号密码</span>
              </div>
            </div>
          </div>
          <div class="login-btn">
            <button type="submit">登录</button>
          </div>
        </div>
      </form>
    </div>
    <div class="supplier_box" v-if="is_show_apply_supplier">
      <div class="supplier_bg_box"></div>
      <div class="tips">您还未申请线上收款，请点击<span @click="toApplySupplier">申请线上收款</span></div>
    </div>
  </el-main>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      is_remember: !1,
      loginForm: {
        account: '',
        password: '',
        code: '',
      },
      is_show_apply_supplier: false,
    };
  },
  created() {
    if (sessionStorage.getItem('token')) this.$router.go(1);
    this.loginForm.account = localStorage.getItem('account') || '';
    this.loginForm.password = localStorage.getItem('password') || '';
    if (localStorage.getItem('password')) {
      this.is_remember = !0;
    }
  },
  computed: {
    ...mapState({
      supplier_type_list: state => state.user.supplier_type_list,
    }),
    is_show_login() {
      if (this.is_show_apply_supplier) return false
      return true
    },
  },
  methods: {
    getremember(val) {
      if (val) {
        localStorage.setItem('account', this.loginForm.account);
        localStorage.setItem('password', this.loginForm.password);
      } else {
        localStorage.removeItem('account');
        localStorage.removeItem('password');
      }
    },
    selectLoginType(i) {
      this.loginType = i;
      for (let i in this.loginForm) this.loginForm[i] = '';
    },
    toApplySupplier() {
      this.getremember(this.is_remember);
      this.$store.dispatch('user/getUserInfo')
      this.$router.push('/supplier/add');
    },
    //登录提交
    loginSubmit(e) {
      e.preventDefault();
      let that = this;
      let loginForm = that.loginForm;
      if (!loginForm.account) return that.$message.error('请填写账号');
      if (!loginForm.password) return that.$message.error('请填写密码');
      //账号密码登录
      that.$axios
        .post(that.$api.user.login, {
          staff_account: loginForm.account,
          staff_password: loginForm.password,
        })
        .then(async (res) => {
          if (res.code == 0) {
            localStorage.setItem('s_type', res.result.store_type);
            sessionStorage.setItem('token', res.result.token);
            this.$store.commit('user/setStoreType', res.result.store_type);
            this.$store.commit('user/setToken', res.result.token);
            this.$store.commit('user/setSkipType', res.result.skip_type);
            this.$store.dispatch('user/getUserInfo')
            // skip_type store_type token
            // 1  是分账用户  是供应商  还未申请过入网的
            // 2  是分账用户  是供应商  分账申请被拒绝
            this.$message({
              message: '登录成功',
              type: 'success',
            });
            // store_type 3- 企业供应商  4-个人供应商 5-个体工商户供应商 供应商集合
            let is_supplier = this.supplier_type_list.findIndex(i => i == res.result.store_type)
            this.$store.commit('user/setIsSupplier', is_supplier !== -1)
            if (is_supplier !== -1) {
              // 未开启分账
              if (res.result.skip_type === 0 || res.result.skip_type === 3) {
                this.getremember(this.is_remember);
                this.$router.push('/index');
              }
              // 开启分账 但未入网 显示去注册入网组件
              if (res.result.skip_type === 1) {
                this.is_show_apply_supplier = true
              }
              // 开启分账 入网未完成 跳转到入网详情页面
              if (res.result.skip_type === 2) {
                this.getremember(this.is_remember);
                this.$router.push('/supplier/edit');
              }
              return
            }
            // 非供应商 进入系统
            if (is_supplier == -1) {
              this.getremember(this.is_remember);
              this.$router.push('/index');
            }

          } else {
            this.$message.error(res.msg);
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
input,button{
  box-sizing: border-box;
}

.el-main {
  height: 100%;
  width: 100%;
  background: url('~@/assets/image/login_bg.png') no-repeat;
  background-size: 100% 100%;

  .logo {
    width: 100%;
  }

  .address {
    width: 100%;
    text-align: center;
    color: #999;
    font-size: 16px;
    bottom: 60px;
  }

  .logo_area {
    position: fixed;
    top: 140px;
    left: 140px;
    display: flex;
    align-items: center;

    .logo_icon {
      width: 68px;
      height: 57px;
    }
    .logo_text {
      width: 104px;
      height: 46px;
      margin-left: 8px;
    }
  }

  .login_desc {
    position: fixed;
    bottom: 190px;
    left: 140px;
    .logo_desc_img {
      width: 398px;
      height: 44px;
    }
    .logo_desc_text {
      font-size: 32px;
      color: #ffffff;
      line-height: 45px;
      margin: 15px 0;
    }
    .jt {
      width: 9px;
      height: 16px;
      &:first-child {
        margin-right: 9px;
      }
    }
  }

  .login-box {
    padding: 80px 55px;
    background: #ffffff;
    box-shadow: 0px 4px 24px 0px rgba(141, 141, 153, 0.16);
    border-radius: 32px;
    position: fixed;
    top: 190px;
    right: 190px;

    .login {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;

      .title {
        font-family: AlibabaPuHuiTi_2_85_Bold;
        font-size: 40px;
        color: #000000;
        line-height: 40 px;
        font-weight: bold;
        align-self: flex-start;
      }

      .form {
        width: 380px;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .password-input {
        margin-top: 40px;
        width: 100%;

        .account {
          margin-bottom: 20px;
        }

        .account,
        .code {
          margin-bottom: 24px;

          .account_input {
            width: 100%;
            height: 60px;
            background: #f2f6fd;
            border-radius: 12px;
            border: none;
            padding: 0 12px;
            outline: #ff6209;
          }
        }

        .forget-password {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 14px;
          padding-left: 5px;

          .left {
            display: flex;
            align-items: center;
            color: #333;

            .el-checkbox {
              margin-right: 8px;

              .el-checkbox__inner {
                width: 20px;
                height: 20px;
              }
            }
          }

          .right {
            color: #999;
            cursor: pointer;
          }
        }
      }
    }
  }
}

.login-btn {
  margin-top: 35px;
  text-align: center;

  button {
    width: 380px;
    height: 45px;
    background: #4c64ff;
    box-shadow: 0px 4px 24px 0px rgba(51, 68, 184, 0.3);
    border-radius: 28px;
    border: 0;
    color: #fff;
    font-size: 18px;
    line-height: 45px;
  }
}

.supplier_box {
  width: 480px;
  height: 400px;
  background-color: rgba(255, 255, 255, 0.4);
  box-shadow: 0px 4px 24px 0px rgba(141, 141, 153, 0.16);
  border-radius: 4px;
  margin-right: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .supplier_bg_box {
    width: 200px;
    height: 200px;
    background: url(../assets/apply_icon.png) no-repeat;
    background-size: cover;
  }
  .tips {
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #333;
    user-select: none;
    span {
      font-size: 18px;
      color: #d01620;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
